// extracted by mini-css-extract-plugin
module.exports = {"container":"ThemeToggle_container__Pm8TY","image":"ThemeToggle_image__8jeYk"};